import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { white } from "tailwindcss/colors";
import { baseUrl } from "../../constants";
import "./Header.css";

const LeftHeader = () => {
  const clubName = "हिन्दी साहित्यिक एवं वाद-विवाद समिति";
  const clubNameLetters = [
    "हि",
    "न्दी",
    " ",
    "सा",
    "हि",
    "त्यि",
    "क",
    " ",
    "ए",
    "वं",
    " ",
    "वा",
    "द",
    "-",
    "वि",
    "वा",
    "द",
    " ",
    "स",
    "मि",
    "ति",
  ];
  const collegeName = "NIT Kurukshetra";
  const collegeNameLetters = [
    "",
    "रा",
    "ष्ट्री",
    "य",
    " ",
    "प्रौ",
    "द्यो",
    "गि",
    "की",
    " ",
    "सं",
    "स्था",
    "न",
    ",",
    " ",
    "कु",
    "रु",
    "क्षे",
    "त्र",
  ];
  return (
    <div
      className="header-main"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* logo */}
      <img
        alt=""
        src={`/image/logo_cropped.png`}
        className="logo animatedItem"
        style={{ "--c": 0, "--swidth": window.screen.availWidth }}
      ></img>
      {/* club name */}
      <div className="ClubName text-white">
        {clubNameLetters.map((k, i) => (
          <span
            key={i}
            style={{ "--c": i + 1, whiteSpace: "pre", lineHeight: "10px" }}
            className="text-md sm:text-xl md:text-3xl animatedItem clubNameLetter"
          >
            {k}
          </span>
        ))}
        {/* collegeName */}
        <div style={{ textAlign: "flex-end" }}>
          {collegeNameLetters.map((k, i) => (
            <span
              key={i}
              style={{
                "--c": i + 1,
                whiteSpace: "pre",
              }}
              className="text-sm animatedItem collegeNameLetter"
            >
              {k}
            </span>
          ))}
        </div>
      </div>
      {/* animation div */}
      <div className="animationDiv"></div>
    </div>
  );
};

const RightHeader = ({ Tabs }) => {
  const [activeTab, setActiveTab] = useState("/Home");
  useEffect(() => {
    const urlList = window.location.href.split("/");
    setActiveTab(
      `/${
        urlList.length
          ? urlList[urlList.length - 1] === ""
            ? "Home"
            : urlList[urlList.length - 1]
          : ""
      }`
    );
  }, [window.location.href.split("/")]);

  return (
    <div
      className="right-header"
      style={{
        display: "flex",
        justifyContent: "space-evenly",
        flexWrap: "wrap",
        color: "white",
      }}
    >
      {Tabs.map((s, i) => (
        <Link
          key={i}
          to={`/${s.url === "home" ? "" : s.url}`}
          className="links"
          onClick={() => setActiveTab(`/${s.url}`)}
          style={{
            margin: "0px 10px",
            cursor: "pointer",
            color: activeTab === `/${s.name}` ? "#eb7a34" : "white",
            borderBottom:
              activeTab === `/${s.name}`
                ? "3px solid #eb7a34"
                : "3px solid rgba(0,0,0,0)",
          }}
        >
          {s.name}
        </Link>
      ))}
    </div>
  );
};

const MobileScreenHamburgerMenu = ({ Tabs }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [activeTab, setActiveTab] = useState("/Home");
  useEffect(() => {
    const urlList = window.location.href.split("/");
    setActiveTab(
      `/${
        urlList.length
          ? urlList[urlList.length - 1] === ""
            ? "Home"
            : urlList[urlList.length - 1]
          : ""
      }`
    );
  }, [window.location.href.split("/")]);
  return (
    <React.Fragment>
      {/* hamburger */}
      <div
        onClick={() => setOpenMenu((pval) => !pval)}
        style={{
          height: "40px",
          width: "40px",
          borderRadius: "50%",
          position: "relative",
          transitionDuration: "400ms",
          backgroundColor: openMenu ? "rgba(0,0,0,0)" : "white",
        }}
      >
        <div
          style={{
            height: "3px",
            width: "25px",
            position: "absolute",
            top: openMenu ? "18px" : "10px",
            left: "7.5px",
            backgroundColor: "rgba(0,0,0,0.7)",
            borderRadius: "25px",
            transitionDuration: "300ms",
            transform: openMenu ? "rotate(45deg)" : "",
          }}
          className="shadowCss"
        ></div>
        <div
          style={{
            height: "3px",
            width: "25px",
            position: "absolute",
            top: "18px",
            left: "7.5px",
            backgroundColor: "rgba(0,0,0,0.7)",
            borderRadius: "25px",
            transitionDuration: "300ms",
            opacity: openMenu ? 0 : 1,
          }}
          className="shadowCss"
        ></div>
        <div
          style={{
            height: "3px",
            width: "25px",
            position: "absolute",
            top: openMenu ? "18px" : "27px",
            left: "7.5px",
            backgroundColor: "rgba(0,0,0,0.7)",
            borderRadius: "25px",
            transitionDuration: "300ms",
            transform: openMenu ? "rotate(-45deg)" : "",
          }}
          className="shadowCss"
        ></div>
      </div>
      {/* tabs */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "3px",
          alignItems: "center",
          width: "100vw",
          transitionDuration: "300ms",
        }}
      >
        {Tabs.map((s, i) => (
          <Link
            key={i}
            to={`/${s.url === "home" ? "" : s.url}`}
            className="links"
            onClick={() => {
              setActiveTab(`/${s.url}`);
              setOpenMenu((pval) => !pval);
            }}
            style={{
              margin: "0px 10px",
              lineHeight: "30px",
              cursor: "pointer",
              color: activeTab === `/${s.name}` ? "#eb7a34" : "white",
              transitionDuration: ".4s",
              height: openMenu ? "30px" : "0px",
              overflow: "hidden",
              backgroundColor:
                activeTab === `/${s.name}`
                  ? "rgba(0,0,0,0.05)"
                  : "rgba(0,0,0,0)",
              width: "100%",
              textAlign: "center",
              borderRadius: "20px",
            }}
          >
            {s.name}
          </Link>
        ))}
      </div>
    </React.Fragment>
  );
};

const Header = () => {
  var Tabs = [
    {
      name: "Home",
      url: "home",
    },
    {
      name: "Glory",
      url: "glory",
    },
    {
      name: "Contact Us",
      url: "contact",
    },
    {
      name: "Our Events",
      url: "events",
    },
    // {
    //   name: "Recent Sponsors",
    //   url: "sponsors",
    // },
  ];

  return (
    <div
      className="header"
      style={{
        padding: "5px 10px",
        display: "flex",
        flexDirection: `${window.screen.availWidth < 693 ? "column" : "row"}`,
        justifyContent: "space-evenly",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100vw",
        // color: "white",
      }}
    >
      {/* logo with name */}
      <LeftHeader />

      {/* tabs */}
      <div className="header-right-part">
        {window.screen.availWidth < 693 ? (
          <div className="self-end">
            <MobileScreenHamburgerMenu Tabs={Tabs} />
          </div>
        ) : (
          <RightHeader Tabs={Tabs} />
        )}
      </div>
    </div>
  );
};

export default Header;
